// получаем Отзывы об отеле на Ajax
export function getMoreReviewsAjax (e)
{
    e.preventDefault();
    const url = e.target.dataset.url;

    if (url !== undefined) {
        BX.ajax({
            method: 'POST',
            dataType: 'html',
            url: this.config.ajaxFOlderUrl + 'latest_reviews_html.php?' + url,
            data: {count: this.config.countLeaveReviews},
            onsuccess: BX.proxy(this.setMoreReviewsResult, this)
        });
    }
}

// Запрашиваем форму "Оставить отзыв" на Ajax
export function getFormLeaveFeedback (e)
{
    e.preventDefault();

    if (false) { // !this.authorized
        window.location.href = '/auth/';
    } else {
        e.target.remove();
        const data = {
            loc: {
                titleForm: BX.message('TITLE_FORM'),
                titleBloc: BX.message('F_TITLE_BLOC'),
                textLiked: BX.message('F_TEXT_LIKED'),
                textNotLiked: BX.message('F_TEXT_NOT_LIKED'),
                btnName: BX.message('F_BTN_POST_REVIEW'),
            },
            form: this.form,
        }

        BX.ajax({
            method: 'POST',
            dataType: 'html',
            url: this.config.ajaxFOlderUrl + 'leave_feedback_html.php',
            data: data,
            onsuccess: BX.proxy(this.leaveFeedbackResultHtml, this)
        });
    }
}

// Обработка данных по нажатию "Опубликовать отзыв"
export function eventBtnFormVerification (e)
{
    e.preventDefault();
    const thisObj = this;

    const inputsTextNode = getFormInputsTypeNode('text');
    const inputsRadioNode = getFormInputsTypeNode('radio');
    const textareaNode = getFormTextareaTypeNode(thisObj);
    thisObj.preloader = this.leaveFeedback.querySelector('[data-preloader]').dataset.preloader;

    if (inputsTextNode) getFormInputsObj(inputsTextNode);
    if (inputsRadioNode) getFormRatingObj(inputsRadioNode);
    if (textareaNode) getFormTextareaObj(textareaNode);

    if (thisObj.authorized) {
        thisObj.formData.inputs = this.fullInput;
        thisObj.formData.textarea = this.fullTextarea;
        thisObj.formData.ratings = this.fullRatings;
    }

    if (!thisObj.dataMsg.error && !thisObj.resultSuccess) {
        if (thisObj.preloader) {
            // console.log(thisObj.config.preloaderUrl);
        }
        setFormLeaveFeedbackAjax(thisObj.formData)
    }

    function getFormInputsTypeNode(type)
    {
        const form = thisObj.leaveFeedback.querySelector('form');
        return form.querySelectorAll(`input[type="${type}"]`);
    }

    function getFormTextareaTypeNode()
    {
        const form = thisObj.leaveFeedback.querySelector('form');
        return form.querySelectorAll('textarea.form_textarea');
    }

    // Перебор input и проверка данных на заполнение
    // формируем результативный массив
    function getFormInputsObj (inputs)
    {
        let errorMsg = [];
        thisObj.fullInput = [];
        thisObj.dataMsg = {};

        inputs.forEach((input) => {
            const inputDiv = input.closest('div.input');

            if (input.hasAttribute("required")) {
                const value = input.value.trim();
                const nameAtt = input.getAttribute('name');

                if (value && value.length !== 0 && value.length >= 3) {

                    // if (nameAtt === 'IN_NAME') {
                    //
                    // }
                    //
                    // if (nameAtt === 'IN_TRAVEL_MONTH') {
                    //
                    // }
                    //
                    // if (nameAtt === 'IN_YEAR_TRAVEL') {
                    //     if (value.length === 4 && isFinite(value)) {
                    //         this.addInputClassSuccess(inputDiv);
                    //     } else {
                    //         this.addInputClassError(inputDiv);
                    //     }
                    // }

                    addClassSuccess(inputDiv);
                    BX.bind(input, 'input', BX.proxy(checkInputEvent, thisObj));

                    const obj = {
                        id: inputDiv.dataset.propId,
                        code: input.getAttribute('name'),
                        value: input.value,
                    }
                    thisObj.fullInput.push(obj);

                } else {
                    errorMsg += input.getAttribute('placeholder')+'<br>';
                    addClassError(inputDiv);
                    BX.bind(input, 'input', BX.proxy(checkInputEvent, thisObj));
                }
            }
        });

        if (errorMsg.length >= 1) {
            thisObj.dataMsg = {
                error: 'true',
                text: BX.message('FORM_MSG_ERROR') + '<br>',
                msg: errorMsg
            };

            msgLeaveFeedbackResult(thisObj.dataMsg)
        }
    }

    // Проверка input при вводе
    function checkInputEvent (e)
    {
        const target = e.target;
        const inputDiv = target.closest('div.input');
        const value = target.value.trim();

        if (value && value.length !== 0 && value.length >= 3) {
            addClassSuccess(inputDiv);
        } else {
            addClassError(inputDiv)
        }
    }

    // формируем объект с рейтингом
    function getFormRatingObj (inputs)
    {
        thisObj.fullRatings = [];
        inputs.forEach((input) => {
            if (input.checked) {
                const rating = input.dataset.rating;
                const value = input.dataset.value;
                const code = input.getAttribute('name');
                const propId = input.closest('div.rating_cont').dataset.propId;

                const obj = {
                    id: propId,
                    code: code,
                    propId: rating,
                    value: value,
                }

                thisObj.fullRatings.push(obj);
            }
        });

        return thisObj.fullRatings;
    }

    // формируем объект textarea
    function getFormTextareaObj (textarea)
    {
        thisObj.fullTextarea = [];
        textarea.forEach((textarea) => {
            const textareaDiv = textarea.closest('div.text_wrapper');
            const value = textarea.value.trim();

            const obj = {
                id: '',
                code: textarea.getAttribute('name'),
                value: textarea.value,
            }

            thisObj.fullTextarea.push(obj);
        });

        return thisObj.fullTextarea;
    }

    // Добавляем класс Error
    function addClassError (input)
    {
        input.classList.remove('_success');
        input.classList.add('_error');
    }

    // Добавляем класс Success
    function addClassSuccess (input)
    {
        input.classList.remove('_error');
        input.classList.add('_success');
    }

    // Отправляем форму "Оставить отзыв" Ajax
    function setFormLeaveFeedbackAjax (data)
    {
        BX.ajax({
            method: 'POST',
            dataType: 'json',
            url: thisObj.config.ajaxFOlderUrl + 'leave_feedback.php',
            data: data,
            onsuccess: BX.proxy(msgLeaveFeedbackResult, thisObj)
        });
    }

    // Показываем результат обработки формы
    function msgLeaveFeedbackResult (data)
    {
        const processingResult = thisObj.leaveFeedback.querySelector('.form_processing_result');

        processingResult.innerHTML = '';
        processingResult.dataset.notifyType = '';

        if (data.error) {
            processingResult.dataset.notifyType = 'error';
            if (data.text) {
                processingResult.innerHTML = data.text;
            }
            processingResult.innerHTML += data.msg;
        }
        if (data.success) {
            thisObj.resultSuccess = true;
            processingResult.dataset.notifyType = 'success';
            processingResult.innerHTML = data.msg;
            thisObj.leaveFeedback.querySelector('button[type="submit"]').setAttribute('disabled', '');

            setTimeout(function(){
                location.reload();
            }, 5000);
        }
    }
}

// Блокируем Поп-пап что бы не исчезало при захвате
export function fancyboxOpen ()
{
    const fancy = document.querySelectorAll('.dws_fancybox');
    const arrFancy = Array.from(fancy)

    if (arrFancy) {
        arrFancy.forEach((btn) => {
            btn.addEventListener('click', function (e) {
                $.fancybox.open({
                    src: e.target.dataset.src,
                    type: 'ajax',
                    // clickSlide : 'false',
                    // clickOutside : 'false',
                    touch: false
                });
            })
        })
    }
}

